import React, {FC, useEffect} from 'react';
import {useMaintenance} from '@modules/maintenance/hooks/useMaintenance';
import {MaintenanceMode} from '@modules/maintenance/ui/views/MaintenanceMode';

interface MaintenanceCheckerProps {
  children: React.ReactNode;
}

export const MaintenanceChecker: FC<MaintenanceCheckerProps> = ({children}) => {
  const {isInMaintenance, checkMaintenanceStatus} = useMaintenance();

  useEffect(() => {
    void checkMaintenanceStatus();
  }, [checkMaintenanceStatus]);

  if (isInMaintenance) return <MaintenanceMode />;

  return <>{children}</>;
};
